import { swapKeysAndValues } from "@helpers/common";

export const orderTypes = { desc: "desc", asc: "asc" };

export const CCBILL_IFRAME_ID = "iframeId";

export const USD_CURRENCY_CODE = "840";

export const subscriptionStatuses = {
  1: "active",
  2: "canceled",
  3: "expired",
  4: "notAvailable",
  5: "pending",
  6: "incomplete",
};

export const minWithdrawalAmount = 20;

export const maxWithdrawalAmount = 4000;

export const promotionStatuses = {
  1: "pending",
  2: "success",
  3: "expired",
};

export const subsMap = swapKeysAndValues(subscriptionStatuses);
export const promotionMap = swapKeysAndValues(promotionStatuses);

export const donation = 1;
export const subscriptions = 2;
export const post = 3;

export const filterPaymentsTypes = [
  { index: 0, name: "ALL", value: "" },
  { index: 1, name: "TIPS", value: "1" },
  { index: 2, name: "POSTS", value: "3" },
];

export const promotionTypes = [
  { index: 0, name: "ALL", value: "" },
  { index: 1, name: "TIPS", value: "1" },
  { index: 3, name: "POSTS", value: "3" },
  { index: 2, name: "SUBSCRIPTIONS", value: "2" },
  { index: 4, name: "NEWCOMER_BONUS", value: "4" },
];

export const agencyTypes = [
  { index: 0, name: "ALL", value: "" },
  { index: 1, name: "TIPS", value: "1" },
  { index: 3, name: "POSTS", value: "3" },
  { index: 2, name: "SUBSCRIPTIONS", value: "2" },
];

export const filterByCurrencyTypes = [
  { index: 0, name: "ALL", value: "" },
  { index: 1, name: "USD", value: "1" },
  { index: 2, name: "PASSION", value: "2" },
];

export const cryptoTxTypes = {
  donation: 1,
  subscription: 2,
  post: 3,
};

export const purchaseTableIds = {
  createdAt: "createdAt",
  nextPaymentAt: "nextPaymentAt",
  price: "price",
  totalSum: "totalSum",
  amount: "amount",
};

export const THREE_DS_PASSED_STATUS = "Y";
export const THREE_DS_CANCELED_STATUS = "N";

export const messageTransactionStatuses = {
  pending: 1,
  success: 2,
  failed: 3,
};

export const paymentGatewayTypes = {
  ccbill: 1,
};

export const maxCardsCount = 5;

export const paymentTypes = {
  saveCard: 1,
  donation: 2,
  post: 3,
  subscription: 4,
  streamTip: 5,
};

export const closeSendTipModal = "close_send_tip_modal";
